import { CustomGameTab } from '@/components/templates/UserActivity/templates/UserActivity/UserActivity'
import { Heading, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next/pages'
import { DoubleVerify } from './Double'
import { CoinflipVerify } from './Coinflip'
import { LootboxVerify } from './Lootbox'
import { JackpotVerify } from './Jackpot'
import { MinesVerify } from './Mines'
import { PlinkoVerify } from './Plinko'
import { sections } from '../utils'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { SignatureVerify } from './Signature'
import { LootboxProvider } from '@/context/LootboxProvider'
import rngModule from '../pkg/rng_v1_web'
import { RunesVerify } from './Runes'

export const Verify = () => {
  const { t } = useTranslation()
  const router = useRouter()
  const { game } = router.query
  const [tabIndex, setTabIndex] = useState<number | null>(null)

  useEffect(() => {
    rngModule()
  }, [])

  useEffect(() => {
    if (router.isReady) {
      const index = sections.findIndex((section) => section.name === game)
      setTabIndex(index !== -1 ? index : 0)
    }
  }, [router.isReady])

  const handleTabsChange = (index: number) => {
    setTabIndex(index)
    router.push({
      pathname: '/verify',
      query: {
        game: sections[index].name,
      },
    })
  }

  if (tabIndex === null) {
    return null
  }

  return (
    <>
      <LootboxProvider>
        <Heading fontSize={'32px'} mb={6}>
          {t('verify.games-result')}
        </Heading>
        <Tabs variant="unstyled" isLazy index={tabIndex} onChange={handleTabsChange}>
          <TabList bg={'none'} p={0} gap={3} display={'flex'} flexWrap={'wrap'} w={'full'} mb={6}>
            {sections.map((section, index) => (
              <CustomGameTab key={index} icon={section.icon} title={section.title} />
            ))}
          </TabList>
          <TabPanels>
            <TabPanel px={0}>
              <SignatureVerify />
            </TabPanel>
            <TabPanel px={0}>
              <DoubleVerify />
            </TabPanel>
            <TabPanel px={0}>
              <MinesVerify />
            </TabPanel>
            <TabPanel px={0}>
              <JackpotVerify />
            </TabPanel>
            <TabPanel px={0}>
              <LootboxVerify />
            </TabPanel>
            <TabPanel px={0}>
              <CoinflipVerify />
            </TabPanel>
            <TabPanel px={0}>
              <RunesVerify />
            </TabPanel>
            <TabPanel px={0}>
              <PlinkoVerify />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </LootboxProvider>
    </>
  )
}
